import React, { useEffect, useState } from "react"
import { Layout as AntdLayout } from 'antd';
import HeaderNew from "./HeaderNew/HeaderNew";
import SidebarNew from "./SidebarNew/SidebarNew";
import SetPasswordModal from "./SetPassword/SetPasswordModal";
import BlancPage from "../BlancPage";
import { useDispatch } from "react-redux";
import { getVerifyToken } from "../../store/auth";


function Layout({ children, currentPageId, auth })
{
    const [modalItem, setModalItem] = useState(null);
    const dispatch = useDispatch()

    const reloadAndReset=()=> {
 
        window.location.reload();
    }
    
    useEffect(()=> {
    if (!auth) {dispatch(getVerifyToken({reloadAndReset}))}
    },[auth])
    return (
        <>
        {!auth && <BlancPage/>}
            {auth && <AntdLayout style={{ minHeight: "100vh" }}>
                <SidebarNew currentPageId={currentPageId} />
                <AntdLayout>
                    <HeaderNew open={setModalItem}/>
                    <AntdLayout.Content style={{ padding: '28px' }}>
                     {  modalItem&&  <SetPasswordModal open={modalItem!==null} close={()=> setModalItem(null)}/>}
                        {children}
                    </AntdLayout.Content>
                </AntdLayout>
            </AntdLayout>}
        </>
    )
}

export default Layout;